import { useEffect, useState } from "react";
import "./ShortIntro.css"
import fetchShortIntroduction from "./packages/fetchShortIntroduction";

const ShortIntro = ({ id, nth, place }) => {
  let [shortIntro, setShortIntro] = useState({});

  useEffect(() => {
    fetchShortIntroduction({
      editionId: id,
      setShortIntro: setShortIntro,
    })
  }, [id]);

  return (
    <div className="pg_si_container" >
      <div className="si_title">
        {nth} <span className="si_colored_text">GEB</span> {place} Business <span className="si_colored_text">Ideas</span>
      </div>
      <div className="si_contents">
        {shortIntro.content ?? ""}
      </div>
    </div>
  );
};

export default ShortIntro;
